<!-- Button -->
<button matTooltip="Panel administracyjny" mat-icon-button *ngIf="isAdmin" [routerLink]="'/admin'">
    <mat-icon color="primary"  [svgIcon]="'tabler_outline:user-bolt'"></mat-icon>
</button>
<button matTooltip="Moje konto"
    mat-icon-button
    data-tour-id="menu-user"
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            [src]="user.avatar">
        <mat-icon
            *ngIf="!showAvatar || !user.avatar"
            [svgIcon]="'tabler_outline:user-circle'"
            [ngClass]="{
                'text-red-500': enableSubscriptions && isSubscriptionExpired,
                'text-amber-500': enableSubscriptions && isSubscriptionExpiringSoon && !isSubscriptionExpired
            }"></mat-icon>
        <span
            *ngIf="enableSubscriptions && isSubscriptionExpired"
            class="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-red-500 flex items-center justify-center ring-2 ring-white dark:ring-gray-900">
            <span class="text-white text-[9px] font-bold leading-none">!</span>
        </span>
        <span
            *ngIf="enableSubscriptions && isSubscriptionExpiringSoon && !isSubscriptionExpired"
            class="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-amber-500 flex items-center justify-center ring-2 ring-white dark:ring-gray-900">
            <span class="text-white text-[8px] font-bold leading-none">▲</span>
        </span>
        <span
            *ngIf="!(enableSubscriptions && (isSubscriptionExpired || isSubscriptionExpiringSoon))"
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
            [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                          'bg-green-500': user.status === 'online',
                          'bg-amber-500': user.status === 'away',
                          'bg-red-500': user.status === 'busy',
                          'bg-gray-400': user.status === 'not-visible'}"
        ></span>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span
            *ngIf="companyLogoUrl"
            class="company-logo-thumb mr-2 inline-flex items-center justify-center overflow-hidden">
            <img [src]="companyLogoUrl" class="max-h-full max-w-full object-contain" alt="Logo">
        </span>
        <span class="flex flex-col leading-none">
            <span>Zalogowano jako</span>
            <span class="mt-1.5 text-md font-medium">{{user.emailAddress}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item [routerLink]="'/konto/moje-konto'" data-tour-id="menu-moje-konto">
        <mat-icon [svgIcon]="'tabler_outline:user'"></mat-icon>
        <span>Moje konto</span>
    </button>
    <!-- Sekcja subskrypcji - widoczna tylko gdy enableSubscriptions = true -->
    <ng-container *ngIf="enableSubscriptions">
        <a mat-menu-item [routerLink]="'/konto/moje-konto/subskrypcja'">
            <mat-icon [svgIcon]="'tabler_outline:crown'"></mat-icon>
            <span class="flex items-center gap-2">
                Subskrypcja
                <span 
                    class="px-1.5 py-0.5 text-xs font-semibold rounded"
                    [ngClass]="{
                        'bg-gray-200 text-gray-700': subscriptionType === 0,
                        'bg-blue-100 text-blue-700': subscriptionType === 1,
                        'bg-purple-100 text-purple-700': subscriptionType === 2,
                        'bg-amber-100 text-amber-700': subscriptionType === 3
                    }">
                    {{ getSubscriptionTypeLabel() }}
                </span>
            </span>
        </a>
        <!-- Alert o kończącej się subskrypcji -->
        <a *ngIf="isSubscriptionExpiringSoon" mat-menu-item [routerLink]="'/konto/subskrypcje'" class="!bg-amber-50">
            <mat-icon [svgIcon]="'tabler_outline:alert-triangle'" class="!text-amber-500"></mat-icon>
            <span class="text-amber-700">Subskrypcja wygasa za {{ subscriptionDaysRemaining }} dni</span>
        </a>
        <!-- Alert o wygasłej subskrypcji -->
        <a *ngIf="isSubscriptionExpired && subscriptionType !== 0" mat-menu-item [routerLink]="'/konto/subskrypcje'" class="!bg-red-50">
            <mat-icon [svgIcon]="'tabler_outline:rocket'" class="!text-red-500"></mat-icon>
            <span class="text-red-700">Przedłuż subskrypcję</span>
        </a>
    </ng-container>
    <a mat-menu-item [routerLink]="'/konto/ustawienia'" data-tour-id="menu-ustawienia">
        <mat-icon [svgIcon]="'tabler_outline:settings'"></mat-icon>
        <span>Ustawienia</span>
    </a>
    <!-- <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
        <span>Status</span>
    </button> -->
    <mat-divider class="my-2"></mat-divider>

    <!-- Powiązane konta — submenu "Przełącz konto" + opcja zarządzania -->
    <button
        *ngIf="connectedAccounts.length >= 1"
        mat-menu-item
        [matMenuTriggerFor]="switchAccountMenu">
        <mat-icon [svgIcon]="'tabler_outline:switch-horizontal'"></mat-icon>
        <span>Przełącz konto</span>
    </button>
    <button
        mat-menu-item
        (click)="openConnectedAccountsDialog()">
        <mat-icon [svgIcon]="'tabler_outline:users-plus'"></mat-icon>
        <span>{{ connectedAccounts.length > 0 ? 'Zarządzaj kontami' : 'Dodaj/zarządzaj kontami' }}</span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Wyloguj się</span>
    </button>
</mat-menu>

<!-- Submenu: lista powiązanych kont do szybkiego przełączenia -->
<mat-menu #switchAccountMenu="matMenu">
    <button
        *ngFor="let acc of connectedAccounts"
        mat-menu-item
        (click)="switchToAccount(acc)">
        <mat-icon [svgIcon]="'tabler_outline:user-circle'"></mat-icon>
        <span class="flex flex-col leading-none">
            <span class="text-sm font-medium">{{ acc.email }}</span>
            <span *ngIf="acc.companyName" class="mt-0.5 text-xs text-gray-500">{{ acc.companyName }}</span>
        </span>
    </button>
</mat-menu>

<!-- <mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu> -->
